const confirm = require('../events/confirm');
const TableSelector = require('./TableSelector.js');
const Filters = require('./Filters.js');
const generalEvents = require('../events/general-events.js');
const isUndefined = require('lodash/isUndefined');
const isArray = require('lodash/isArray');
const isMobile = require('is-mobile');
const Lang = require('lang');
const ga4 = require('../ga4/ga4');

const ExpensesActions = (function() {
  const tableSelector = new TableSelector();
  const container = $('#expenses-container');
  const filtersContainer = $('#expenses-filters');
  const selecionarRelatorioTemplate = document.getElementById('selecionar-relatorio');
  let filters = null;
  ExpensesActions.URL = /despesas/;

  const actions = {
    container: $('#action-container')
  };

  actions.add = actions.container.find('[data-add]');
  actions.delete = actions.container.find('[data-delete]');
  actions.label = actions.container.find('p');

  function ExpensesActions() {
    const _this = this;
    init.call(this);
    filters = new Filters(route('app.despesas.filtrar'), filtersContainer);
    filters.before = function() {
      nifty.body.overlay('show');
    };
    filters.after = function(html) {
      nifty.body.overlay('hide');
      _this.resetDataView(html);
    };
  }

  ExpensesActions.prototype.disableActions = function() {
    this.setTotal(0).disableDelete().disableAdd();
    return this;
  };

  ExpensesActions.prototype.enableActions = function() {
    this.setTotal().enableDelete().enableAdd();
    return this;
  };

  ExpensesActions.prototype.enableDelete = function() {
    actions.delete.prop('disabled', false);
    return this;
  };

  ExpensesActions.prototype.disableDelete = function() {
    actions.delete.prop('disabled', true);
    return this;
  };

  ExpensesActions.prototype.enableAdd = function() {
    actions.add.prop('disabled', false);
    return this;
  };

  ExpensesActions.prototype.disableAdd = function() {
    actions.add.prop('disabled', true);
    return this;
  };


  ExpensesActions.prototype.setTotal = function(num) {
    num = isUndefined(num) ? tableSelector.selectedTotal() : num;
    actions.label.text(num + ' ' + Lang.get('js/src/classes/ExpensesActions.selected_expenses'));
    if (num > 0) {
      actions.label.removeClass('disabled');
    } else {
      actions.label.addClass('disabled');
    }
    return this;
  };

  ExpensesActions.prototype.resetDataView = function(html) {
    const _this = this;
    if (html) {
      container.html(html);
      init.call(this);
      confirm.init();
      return this;
    }

    return filters.filterData();
  };

  ExpensesActions.prototype.checkExpenseHaveSameCostCenterOfReport = function(report) {
    const _this = this;
    const expenses = tableSelector.selectedValues();
    let responseCheck = [];
    $.ajax({
      method: 'POST',
      url: route('app.despesas.verificar-centro-custo-relatorio'),
      async: false,
      data: {
        relatorio: report,
        despesas: expenses
      },
      success: function(response) {
        responseCheck = response;
      },
      error: function(response) {
        responseCheck = response.responseJSON;
        bootbox.alert({
          title: Lang.get('js/src/classes/ExpensesActions.ops'),
          message: response.responseJSON.message,
          size: 'small'
        });
      }
    });
    return responseCheck;
  }

  ExpensesActions.prototype.addSelectedToReport = function(report) {
    const _this = this;
    const expenses = tableSelector.selectedValues();
    container.overlay('show');
    return $.ajax({
      method: 'POST',
      url: route('app.despesas.mudarRelatorio'),
      data: {
        relatorio: report,
        despesas: expenses
      },
      success: function(response) {
        _this.resetDataView();
        bootbox.alert({
          title: Lang.get('js/src/classes/ExpensesActions.success'),
          message: response.message,
          size: 'small'
        });
      },
      error: function(response) {
        let message;
        if (
          response.responseJSON.hasOwnProperty('relatorio')
          && typeof response.responseJSON.relatorio === 'object'
          && response.responseJSON.relatorio.constructor === Array
        ) {
          message = response.responseJSON.relatorio.join('<br>');
        } else {
          message = response.responseJSON.message;
        }
        container.overlay('hide');
        bootbox.alert({
          title: Lang.get('js/src/classes/ExpensesActions.ops'),
          message: message,
          size: 'small'
        });
      }
    });
  };

  ExpensesActions.prototype.confirmChangeCostCenterExpenses = function(report, nameCostCenter) {
    const _this = this;
    bootbox.confirm({
      title: Lang.get('js/src/classes/ExpensesActions.title_modal_confirm_change_cost_center'),
      message: Lang.get('js/src/classes/ExpensesActions.message_modal_confirm_change_cost_center', {'nameCostCenter': nameCostCenter}),
      buttons: {
        confirm: {
          label: Lang.get('js/common/words.yes'),
          className: 'btn-success',
        },
        cancel: {
          label: Lang.get('js/common/words.cancel'),
          className: 'btn-danger'
        }
      },
      callback: function (result) {
        if (result) {
          _this.addSelectedToReport(report);
        }
      }
    });
  }


  ExpensesActions.prototype.remove = function(ids) {
    let counter = 0;
    ids = isArray(ids) ? ids : arguments;

    [].forEach.call(ids, function(id, n) {
      tableSelector.remove(id);
      counter++;
    });

    return counter;
  };

  ExpensesActions.prototype.canDelete = function() {
    const canDelete = [];
    tableSelector
      .selectedValues()
      .forEach(function(id) {
        canDelete.push(tableSelector.getInfo(id).canDelete);
      });

    return !canDelete.includes(false);
  };

  ExpensesActions.prototype.canEdit = function() {
    const canEdit = [];
    tableSelector
      .selectedValues()
      .forEach(function(id) {
        canEdit.push(tableSelector.getInfo(id).canEdit);
      });

    return !canEdit.includes(false);
  };

  ExpensesActions.prototype.checkCurrency = function() {
    const currencies = [];
    tableSelector
      .selectedValues()
      .forEach(function(id) {
        currencies.push(tableSelector.getInfo(id).currency);
      });

    // removing repeated currencies
    const filtered = currencies.filter(function(elem, ind, arr){
      return arr.indexOf(elem) == ind;
    });

    return filtered.length === 1
  };

  ExpensesActions.prototype.canExecuteSomeAction = function() {
    return this.canEdit() || this.canDelete();
  };

  ExpensesActions.prototype.delete = function() {
    const _this = this;
    const expenses = tableSelector.selectedValues();
    container.overlay('show');
    return $.ajax({
      method: 'DELETE',
      url: route('app.despesas.destroyMany'),
      data: {
        despesas: expenses
      },
      success: function(html) {
        container.overlay('hide');
        bootbox.alert({
          title: Lang.get('js/src/classes/ExpensesActions.success'),
          message: Lang.get('js/src/classes/ExpensesActions.expenses_successfully_removed'),
          size: 'small'
        });
        _this.remove(expenses);
        init.call(_this);
      },
      error: function(data) {
        container.overlay('hide');
        bootbox.alert({
          title: Lang.get('js/src/classes/ExpensesActions.ops'),
          message: Lang.get('js/src/classes/ExpensesActions.remove_expense_error_message'),
          size: 'small'
        });
      }
    });
  };

  const addEvents = function() {
    const _this = this;
    const data = tableSelector.getBody();
    nifty.body.overlay({fixed: true});

    if (isMobile()) {
      const mobileFilter = document.getElementById('mobile-expenses-filter');
      if (mobileFilter) {
        mobileFilter.addEventListener('change', function(e) {
          const all = mobileFilter.checked ? 0 : 1;

          nifty.body.overlay('show');
          $.get(route('app.despesas.index') + '?all=' + all, function(html) {
            nifty.body.overlay('hide');
            html = $(html);
            const itens = html.find('.mobile-grid__item');
            $('.mobile-grid__item-container').html(itens.length ? itens : html);
          });
        });
      }
    }

    data.on('change', function(e) {
      const count = tableSelector.selectedTotal();
      const values = tableSelector.selectedValues();
      actions.add.off('click');
      actions.delete.off('click');

      $('#avisoStatusDeveSerAbertoOuAvulsa').hide()

      //pra cada despesa selecionada no checkbox
      values.forEach(function (id) {
        //pega a info canDelete na row da despesa
        const canDelete = $('tr[data-href$="' + id + '"] .checkbox-cell input').data('info').canDelete
        if(!canDelete) {
          //se não for deletavel mostra o aviso com os status deletaveis
          $('#avisoStatusDeveSerAbertoOuAvulsa').show()
        }
      })

      if (count > 0) {
        _this.setTotal();
        if (_this.canEdit() && _this.checkCurrency()) {
          _this.enableAdd();
          actions.add.click(events.add.bind(_this));
        } else {
          _this.disableAdd();
        }
        if (_this.canDelete()) {
          _this.enableDelete();
          actions.delete.click(events.delete.bind(_this));
        } else {
          _this.disableDelete();
        }
      } else {
        _this.disableActions();
      }
    });
  };

  const events = {
    add: function(evt) {
      const _this = this;
      const tipoAprovacao = evt.target.getAttribute('data-approval-type');
      const modal = bootbox.dialog({
        title: Lang.get('js/src/classes/ExpensesActions.add_report'),
        message: selecionarRelatorioTemplate.innerHTML,
        buttons: {
          cancel: {
            label: Lang.get('js/src/classes/ExpensesActions.cancel'),
            className: 'btn-danger',
            callback() {
              ga4.event('-expenses_cancelReport')();
            }
          },
          confirmar: {
            label: Lang.get('js/src/classes/ExpensesActions.save'),
            className: 'btn-success',
            callback() {
              const report = this.find('#idDespesa').val();
              const checkSameCostCenter = _this.checkExpenseHaveSameCostCenterOfReport(report);
              ga4.event('-expenses_saveReport')();

              if (!checkSameCostCenter.success) {
                return;
              }

              if (tipoAprovacao != 'CC') {
                _this.addSelectedToReport(report);
                return;
              }

              if (checkSameCostCenter.data.centrosCustosIguais) {
                _this.addSelectedToReport(report);
                return;
              }

              _this.confirmChangeCostCenterExpenses(report, checkSameCostCenter.data.nameCostCenter);
              return;
            }
          }
        }
      });
      modal.on('shown.bs.modal', function(e) {
        const select = modal.find('.dynamic-select');
        select.on('change', function () {
          ga4.event('-expenses_expenseReport')(this);
        });
        select.selectize();
        const relatorios = modal.find('#idDespesa');
        const selectize = relatorios[0].selectize;
        if (!selectize.items.length) {
          // Linhas abaixo exibem erro ao abrir o modal para mostrar o campo vazio
          // relatorios.parent().addClass('has-error');
          // relatorios.parent().append('<span class="help-block">' + Lang.get('js/src/classes/ExpensesActions.no_reports_to_choose') + '</span>');
          modal.find('[data-bb-handler="confirm"]').prop('disabled', true);
        }
      });
    },
    delete: function(evt) {
      const _this = this;
      const count = tableSelector.selectedTotal();
      bootbox.confirm({
        title: Lang.get('js/src/classes/ExpensesActions.remove_expenses'),
        message: Lang.get('js/src/classes/ExpensesActions.sure_to_remove_expense', {count: count}),
        size: 'small',
        callback: function(confirmed) {
          ga4.event('-expenses_confirmDeleteExpense')();
          if (confirmed) {
            _this.delete();
          }
        }
      })
    }
  };

  const init = function() {
    this.disableActions();
    tableSelector.refresh();
    addEvents.call(this);
    generalEvents();
    container.overlay('hide');
  };


  return ExpensesActions;
}());

module.exports = ExpensesActions;

